import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'crypto-withdrawal',
  templateUrl: 'crypto-withdrawal.component.html',
  styleUrls: ['crypto-withdrawal.component.scss']
})

export class CryptoWithdrawalComponent implements OnInit {

  withDrawForm: FormGroup;
  step: "step-1" | "step-2" | "step-3" | "step-4" = "step-1"
  cryptoType: string;

  constructor(
    private fb: FormBuilder,
    private translateService: TranslateService,
  ) {
    this.initForm();
  }

  ngOnInit() { }

  initForm(): void {
    this.withDrawForm = this.fb.group({
      amount: [null, Validators.required],
      address: [null, Validators.required],

    });

  }

  selectCryptoType(type: string) {
    this.cryptoType = type;
    this.step = "step-2"
  }

  confirm() {
    this.step = "step-3"
  }

}
